import { type CustomResponseFormat } from "api/instance";
import { DataState } from "../recoil/onboardingDataAtom";
import { axiosInstancePromotion } from "./instancePromotion";
import { OnboardingDemographicType } from "./onboardingApi";

export const WEB_FUNNEL_DOMAIN = "web-funnel";

export const WEB_FUNNEL_BEGIN = "begin";
export const WEB_FUNNEL_IDENTIFY = "identify";
export const WEB_FUNNEL_PAGE_DATA_SAVE_ENDPOINT = "page-data/save";
export const WEB_FUNNEL_GENDER_SUBMIT_ENDPOINT = "gender/submit";
export const WEB_FUNNEL_EVENT_TRACK_ENDPOINT = "event/track";
export const WEB_FUNNEL_AGE_SUBMIT_ENDPOINT = "age/submit";
export const WEB_FUNNEL_JOB_SUBMIT_ENDPOINT = "job/submit";
export const WEB_FUNNEL_DEMOGRAPHIC_LOAD_ENDPOINT = "demographic/load";

export interface WebFunnelBeginResultType {
  onboardingType?: string;
}

export const webFunnelApi = {
  begin: (mixpanelDistinctId: string, onboardingType?: string) =>
    axiosInstancePromotion.post<CustomResponseFormat<WebFunnelBeginResultType>>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_BEGIN}`,
      {
        clientId: mixpanelDistinctId,
        ...(onboardingType && { onboardingType }),
        version: "v4",
      }
    ),

  identify: (mixpanelDistinctId: string) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_IDENTIFY}`,
      {
        clientId: mixpanelDistinctId,
      }
    ),

  savePageData: (mixpanelDistinctId: string, pageId: string, data: DataState) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_PAGE_DATA_SAVE_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        pageId: pageId,
        data: JSON.stringify(data),
      }
    ),

  submitAge: (mixpanelDistinctId: string, age: number) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_AGE_SUBMIT_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        age: age,
      }
    ),

  submitJob: (mixpanelDistinctId: string, job: string) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_JOB_SUBMIT_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        job: job,
      }
    ),

  submitGender: (mixpanelDistinctId: string, gender: string) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_GENDER_SUBMIT_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        gender: gender,
      }
    ),

  trackEvent: (eventName: string, properties?: { [key: string]: any }) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_EVENT_TRACK_ENDPOINT}`,
      {
        eventName: eventName,
        properties: properties,
      }
    ),
  loadDemographic: () =>
    axiosInstancePromotion.get<CustomResponseFormat<OnboardingDemographicType>>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_DEMOGRAPHIC_LOAD_ENDPOINT}`
    ),
};
